

import React, { useContext, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import CloudformationOutputs from '../CloudformationOutputs.json'
import Modal from '../ui-elements/Modal'

type Props = {
  question: ObjectStringKeyAnyValue,
  classString?: string
}

function FormatQuestionTitle({
  question,
  classString = 'font-righteous text-brandblue font-bold text-xl'
}: Props) {

  const {
    tableData,
    currentOrganisation
  } = useContext(GlobalContext)


  let titleText = question.QuestionText || `Question ID: ${question.Id}`
  let parentQuestionId = question.parentQuestionId
  let parentQuestion = tableData && tableData.ChecklistQuestions && tableData.ChecklistQuestions[parentQuestionId]

  if (question.AssetId) {
    const assetName = question.AssetId && tableData && tableData.Assets && tableData.Assets[question.AssetId] && tableData.Assets[question.AssetId].AssetName
    titleText = assetName ? 
    `Reading for ${assetName} (ID #${question.AssetId})` :
    `Reading for  asset ID #${question.AssetId})` 
  }



  return <div>
    <p className={classString}>{titleText}</p>
    {parentQuestion && <p className={`text-xs italic`}>Followup question for: "{parentQuestion.QuestionText}"</p>}
  </div>
}

export default FormatQuestionTitle